/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_IndexInputs */

const en_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match by Index`)
};

const fr_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondance par index`)
};

const de_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übereinstimmung nach Index`)
};

const it_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrispondenza per indice`)
};

const ru_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совпадение по индексу`)
};

const es_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencia por índice`)
};

const zh_cn2_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按索引匹配`)
};

const ja_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インデックスによる一致`)
};

const hi_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचकांक के अनुसार मिलान करें`)
};

const pt_pt2_metadata_merge_match_by_index = /** @type {(inputs: Metadata_Merge_Match_By_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondência por índice`)
};

/**
* | output |
* | --- |
* | "Match by Index" |
*
* @param {Metadata_Merge_Match_By_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_index = /** @type {((inputs?: Metadata_Merge_Match_By_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_match_by_index(inputs)
	if (locale === "de") return de_metadata_merge_match_by_index(inputs)
	if (locale === "it") return it_metadata_merge_match_by_index(inputs)
	if (locale === "ru") return ru_metadata_merge_match_by_index(inputs)
	if (locale === "es") return es_metadata_merge_match_by_index(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_match_by_index(inputs)
	if (locale === "ja") return ja_metadata_merge_match_by_index(inputs)
	if (locale === "hi") return hi_metadata_merge_match_by_index(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_match_by_index(inputs)
	return en_metadata_merge_match_by_index(inputs)
});